import React from 'react';
import { connect } from 'react-redux';
import { ResponsiveImage, ResponsiveImageSize } from 'react-responsive-image';
import styleHelper from './../../../helpers/style';


class SmallAdCard extends React.Component {
  constructor(props) {
    super(props);


    // used by React as the component name
    this.displayName = 'SmallAdCard';
  }


  /**
   * Renders component
   * @returns {ReactElement} ReactElement
   */
  render() {
    const data = this.props.data;
    const state = this.props.smallCardFrameworkState;
    const activeClass = (state.currentCardIteration + 1 === data.order) ?
      ' active' : '';
    const className = 'card component-small-ad-card' + activeClass;

    return (
      <section
        className={className}
        style={this.props.style}
      >
        <a href={data.clickThroughUrl}>
          <img
            alt=''
            className='trpx'
            src={data.trackingPixelUrl}
          />
          <ResponsiveImage ref='image'>
            <ResponsiveImageSize
              default
              minWidth={0}
              path={data.path}
            />
            <ResponsiveImageSize
              minWidth={768}
              path={data.largePath}
            />
          </ResponsiveImage>
        </a>
      </section>
    );
  }
}


/**
 * Expected propTypes
 * @prop {Object} data - An array of card React components
 * @prop {Number} iteration - The iteration of the component
 * @prop {Number} largeBreakpoint - A width breakpoint
 * @prop {Object} mediaLabCardFrameworkState - The state of the
 * container component
 * @prop {Object} smallCardFrameworkState - The state of the
 * SmallCardFramework component
 * @prop {Object} style - A style object
 */
SmallAdCard.propTypes = {
  data: React.PropTypes.object.isRequired,
  iteration: React.PropTypes.number.isRequired,
  largeBreakpoint: React.PropTypes.number,
  mediaLabCardFrameworkState: React.PropTypes.object.isRequired,
  smallCardFrameworkState: React.PropTypes.object.isRequired,
  style: React.PropTypes.object,
};


export default connect(({ mediaLabCardFrameworkState, smallCardFrameworkState }) =>
  ({ mediaLabCardFrameworkState, smallCardFrameworkState }))(SmallAdCard);



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/cards/small/SmallAdCard.jsx
 **/